import { useMemo } from 'react';
import { useAdfoxContext } from 'shared/context/AdfoxContext';
import {
  PParams,
  TAdBannerMicrofrontendParameters,
  TTgbNativedescGeneralDesign,
} from 'shared/types/microfrontends/adBanner';

function getPuidsFromParams(params: Record<string, string>, pParams: PParams): Record<string, string> {
  const puids = { ...params };

  Object.keys(pParams).forEach(key => {
    delete puids[key];
  });

  return puids;
}

const TGB_DESIGN_MAPPER: Record<string, TTgbNativedescGeneralDesign> = {
  aside: 'desktop-card',
  footer: 'desktop-listingJK',
};

export function useAdBannerMicrofrontendParameters(): TAdBannerMicrofrontendParameters {
  const { params, sizes, postViewAnalyticsData, regionId } = useAdfoxContext();
  const place = postViewAnalyticsData.place;

  const pParams = useMemo(
    (): PParams => ({
      p1: params.p1,
      p2: params.p2,
    }),
    [params.p1, params.p2],
  );

  const puids = useMemo(() => getPuidsFromParams(params, pParams), [params, pParams]);

  return useMemo(
    (): TAdBannerMicrofrontendParameters => ({
      place,
      puids,
      pParams,
      position: null,
      galleryPosition: null,
      isSp: postViewAnalyticsData.isSp ?? false,
      regionId,
      sizes: {
        width: sizes.width,
        height: sizes.height,
      },
      tgbNativedescGeneralDesign: TGB_DESIGN_MAPPER[place] || 'desktop-card',
    }),
    [place, postViewAnalyticsData.isSp, puids, pParams, regionId, sizes.height, sizes.width],
  );
}
